// Kiểm hình doc ở phiên bản hiện tại. Sai hình thì ném: store sẽ cách ly bản đó.
import { SAVE_VERSION, isPlainObject, type RawDoc, type SaveDoc } from './types';

export class InvalidSaveError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'InvalidSaveError';
  }
}

function finite(d: RawDoc, k: string): number {
  const v = d[k];
  if (typeof v !== 'number' || !Number.isFinite(v))
    throw new InvalidSaveError(`field ${k} must be a finite number`);
  return v;
}

export function validateDoc(d: RawDoc): SaveDoc {
  if (d.v !== SAVE_VERSION) throw new InvalidSaveError(`expected v${SAVE_VERSION}, got ${String(d.v)}`);
  finite(d, 'createdAt');
  finite(d, 'savedAt');
  const seed = finite(d, 'seed');
  if (!Number.isInteger(seed) || seed < 0 || seed > 0xffffffff)
    throw new InvalidSaveError('seed must be uint32');
  if (!isPlainObject(d.core)) throw new InvalidSaveError('core must be an object');
  if (!isPlainObject(d.device)) throw new InvalidSaveError('device must be an object');
  const ledger = d.core.ledger;
  if (!isPlainObject(ledger)) throw new InvalidSaveError('core.ledger must be an object');
  if (!isPlainObject(ledger.flags)) throw new InvalidSaveError('core.ledger.flags must be an object');
  for (const [k, v] of Object.entries(ledger.flags)) {
    if (typeof v !== 'boolean' && typeof v !== 'number' && typeof v !== 'string')
      throw new InvalidSaveError(`flag ${k} has bad type`);
  }
  if (!Array.isArray(ledger.claimed) || !ledger.claimed.every((x) => typeof x === 'string'))
    throw new InvalidSaveError('core.ledger.claimed must be string[]');
  // Slice của module: có thì phải là object; nội dung do hydrate của module làm sạch (về mặc định).
  for (const k of ['cultivation', 'story', 'inventory', 'trial', 'cave'] as const)
    if (k in d.core && !isPlainObject(d.core[k])) throw new InvalidSaveError(`core.${k} must be an object`);
  return d as unknown as SaveDoc;
}
